import React from 'react'
import Lottie from 'lottie-react'
import * as animationData from '@public/lottie/business.json'

export const BusinessLottie = () => {
	return (
		<Lottie
			animationData={animationData}
			loop={true}
			style={{
				width: 500,
				height: 300,
			}}
			rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
		/>
	)
}
